/**
 * @generated SignedSource<<559c3d37e4a98f768cccdc67e2fbd9a5>>
 * @relayHash 98d7f7fd9930e899dc9b03c10f35aa2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 881d1d8d29211658689325420e8c7ef222c43c80329551602680076850056533

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ServiceDeskPortalSettingsQuery$variables = {
  cloudId: string;
  cloudIdString: string;
};
export type ServiceDeskPortalSettingsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CustomerPortalSettingsPage">;
};
export type ServiceDeskPortalSettingsQuery = {
  response: ServiceDeskPortalSettingsQuery$data;
  variables: ServiceDeskPortalSettingsQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": rovoAgentConfigExperienceFG_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider": extractRovoAgentConfigurationPackageFG_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider: {
    readonly get: () => boolean;
  };
});

import extractRovoAgentConfigurationPackageFG_provider from '@atlassian/jira-relay-provider/src/extract-rovo-agent-configuration-package.relayprovider';
import rovoAgentConfigExperienceFG_provider from '@atlassian/jira-relay-provider/src/jsm-portal-rovo-agent-config-experience.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdString"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudIdString"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyEditableAgents": true
    }
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "args": (v3/*: any*/),
  "concreteType": "AgentStudioAgentsConnection",
  "kind": "LinkedField",
  "name": "agentStudio_getAgents",
  "plural": false,
  "selections": [
    {
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "hasNextPage"
        },
        {
          "kind": "ScalarField",
          "name": "endCursor"
        }
      ]
    },
    {
      "concreteType": "AgentStudioAgentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "AgentStudioAssistant",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "id"
            },
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "kind": "ScalarField",
              "name": "externalConfigReference"
            },
            {
              "kind": "ScalarField",
              "name": "identityAccountId"
            },
            {
              "kind": "ScalarField",
              "name": "creatorType"
            },
            (v4/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "cursor"
        }
      ]
    }
  ]
},
v6 = {
  "args": (v3/*: any*/),
  "filters": [
    "cloudId",
    "input"
  ],
  "handle": "connection",
  "key": "RovoAgent_agentStudio_getAgents",
  "kind": "LinkedHandle",
  "name": "agentStudio_getAgents"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ServiceDeskPortalSettingsQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "cloudIdString",
            "variableName": "cloudIdString"
          }
        ],
        "kind": "FragmentSpread",
        "name": "CustomerPortalSettingsPage"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ServiceDeskPortalSettingsQuery",
    "selections": [
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/)
        ]
      },
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "args": [
              (v2/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "atlassianStudio_userSiteContext",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "AtlassianStudioUserProductPermissions",
                    "kind": "LinkedField",
                    "name": "userPermissions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isAbleToCreateAgents"
                      }
                    ]
                  }
                ],
                "type": "AtlassianStudioUserSiteContextOutput"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "881d1d8d29211658689325420e8c7ef222c43c80329551602680076850056533",
    "metadata": {},
    "name": "ServiceDeskPortalSettingsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmportalrovoagentconfigexperiencerelayprovider": rovoAgentConfigExperienceFG_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcextractrovoagentconfigurationpackagerelayprovider": extractRovoAgentConfigurationPackageFG_provider
    }
  }
};
})();

(node as any).hash = "eba27bb3ef600ddb29c1aba82b2a9c51";

export default node;
